import React, {FC} from 'react';
import {Subject} from 'rxjs';

import {GlobalStyles} from '../../libs/shared/ui/src/styles/globalStyles';
import {SingleUseValue} from '../helpers/memoryHelpers';
import {AppPanelId} from '../store/panels/panelStateBase';
import {AppBanners} from './app/banners/appBanners';
import {AppBannersHost} from './app/banners/appBannersHost';
import {DemoInboxLoadingModalContainer} from './app/demoInboxLoadingModal/demoInboxLoadingModalContainer';
import {HelpChatContainer} from './app/helpChat/helpChatContainer';
import {InviteTeammatePopoverContainer} from './app/inviteTeammate/inviteTeammatePopoverContainer';
import {AppContentContainer} from './appContentContainer';
import {WelcomeCarouselContainer} from './carousel/welcome/welcomeCarouselContainer';
import {ElectronUICapabilities} from './electronUICapabilities';
import {AppGrammarlyButtonHost} from './grammarly/appGrammarlyButtonHost';
import {GoogleAnalyticsFrame} from './inboxes/googleAnalyticsFrame';
import {LegacyFrameRawBoot} from './legacy/legacyFrameHelpers';
import {SessionTimeoutDialog} from './sessionTimeoutDialog';
import {TitleContainer} from './title/titleContainer';

/*
 * Props.
 */

interface AppProps {
  panelId: AppPanelId;
  rawBoot$?: Subject<LegacyFrameRawBoot>;
  initialRawBoot?: SingleUseValue<unknown>;
}

/*
 * Component.
 */

export const App: FC<AppProps> = ({panelId, rawBoot$, initialRawBoot}) => (
  <>
    <GlobalStyles />
    <ElectronUICapabilities />
    <TitleContainer />
    <SessionTimeoutDialog />

    <AppContentContainer panelId={panelId} rawBoot$={rawBoot$} initialRawBoot={initialRawBoot} />
    <AppGrammarlyButtonHost panelId={panelId} />
    <AppBannersHost panelId={panelId} />

    <AppBanners panelId={panelId} />
    <WelcomeCarouselContainer panelId={panelId} />
    <InviteTeammatePopoverContainer panelId={panelId} />
    <DemoInboxLoadingModalContainer panelId={panelId} />
    <HelpChatContainer panelId={panelId} />
    <GoogleAnalyticsFrame />
  </>
);
